import React, { useEffect, useRef, useState } from "react";
import "./index.css";
export default function ScrollAnimado() {
  return (
    <>
      <div className="icon-scroll"></div>
    </>
  );
}
